export default __webpack_public_path__ + "17d4e65.png";